export const USER_GET_ALL_FUNCTIONS = "USER_GET_ALL_FUNCTIONS";
export const USER_GET_ALL_FUNCTIONS_SUCCESS = "USER_GET_ALL_FUNCTIONS_SUCCESS";
export const USER_GET_ALL_FUNCTIONS_ERROR = "USER_GET_ALL_FUNCTIONS_ERROR";
export const USER_GET_ALL_FUNCTIONS_RESET = "USER_GET_ALL_FUNCTIONS_RESET";
export const USER_DELETE_SINGLE_USER_FUNCTION =
  "USER_DELETE_SINGLE_USER_FUNCTION";
